"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CalendarClock24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 1H8V3H16V1H18V3H22V11.101C23.2372 12.3636 24 14.0927 24 16C24 17.9073 23.2372 19.6364 22 20.899V21H21.899C20.6364 22.2372 18.9073 23 17 23C15.0927 23 13.3636 22.2372 12.101 21H2V3H6V1ZM10.6736 19C10.2417 18.0907 10 17.0736 10 16C10 14.0413 10.8045 12.2705 12.101 11H11V9H13V10.2547C13.604 9.83338 14.2776 9.50489 15 9.28988V9H17C18.0736 9 19.0907 9.24169 20 9.67363V5H18H16H8H6H4V19H10.6736ZM9 9V11H7V9H9ZM9 15V13H7V15H9ZM12 16C12 13.2386 14.2386 11 17 11C19.7614 11 22 13.2386 22 16C22 18.7614 19.7614 21 17 21C14.2386 21 12 18.7614 12 16ZM19.8431 17.2293L18.7631 18.6693L16 16.5409V12H18V15.6409L19.8431 17.2293Z", fill: "#A8ADB8" }));
}
function CalendarClock24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CalendarClock24Svg, Object.assign({}, svgProps)));
}
exports.default = CalendarClock24;
//# sourceMappingURL=CalendarClock24.js.map